var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop)?_c('v-footer',{staticClass:"theme--dark",attrs:{"app":"","fixed":""}},[_c('span',{staticClass:"mx-auto"},[_vm._v("Copyright © "+_vm._s(_vm._f("moment")(new Date(),"YYYY"))+" All Rights Reserved.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }